import './aside.less'

import {View, classes, m} from '@codeurs/front'

import {Children} from 'mithril'

export class Aside extends View<{
	class?: string
	aside: (...args: any[]) => Children
	showfilter?: boolean
}> {
	render = this.render

	view() {
		const {children, class: className, aside, showfilter} = this.attrs
		return m('.aside', classes(className), [
			m('aside.aside-sidebar',
				{class: className + (showfilter ? ' mod-isfolded' : '')},
				m(aside)
			),
			m('.aside-content', children)
		])
	}
}
